import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SafetyRoute from 'components/kea/SafetyRoute';
import asyncComponent from 'util/asyncComponent';
import SubmitNewPassword from 'containers/SignIn/SubmitNewPassword';
import WelcomePage from './WelcomePage';
import LoadingPage from './LoadingPage';
import ShellBootstrapEntry from './ShellBootstrapEntry';
import AuthRecoveryPage from './AuthRecoveryPage';

const Embedded = ({ match }) => (
  <Switch>
    <SafetyRoute path={`${match.url}/app`} exact render={(props) => <ShellBootstrapEntry {...props} />} />
    <SafetyRoute path={`${match.url}/signin`} exact render={(props) => <WelcomePage {...props} />} />
    <SafetyRoute path={`${match.url}/forgot-password`} exact render={(props) => <SubmitNewPassword {...props} />} />
    <SafetyRoute path={`${match.url}/register`} exact render={(props) => <AuthRecoveryPage {...props} />} />
    <SafetyRoute path={`${match.url}/loading`} exact render={(props) => <LoadingPage {...props} />} />
    <Route component={asyncComponent(() => import('../../app/routes/404'))} />
  </Switch>
);

export default Embedded;
